import { useUser } from "@/store/user";

export const home = (to, from) => {
    const userStore = useUser();
    if (userStore.isLoggedIn) {
        return { name: "my-services" };
    }
    return { name: "public-home" };
};
